import React from 'react';
import { useNavigate } from '@tanstack/react-router';
import { Button } from '../../components/ui/button';
import QuizForm from '../../components/teacher/QuizForm';
import type { Quiz } from '../../types';
import { api, useMutation } from '../../lib/convex';
import { TeacherAuth, SignOut } from '../../components/auth/TeacherAuth';

const CreateQuizPage: React.FC = () => {
  return (
    <TeacherAuth>
      <CreateQuizContent />
    </TeacherAuth>
  );
};

const CreateQuizContent: React.FC = () => {
  const navigate = useNavigate();
  
  // Set up the mutation to create a quiz
  const createQuiz = useMutation(api.quizzes.create);

  const handleCreateQuiz = async (quiz: Quiz) => {
    try {
      // Create the quiz in the database
      const quizId = await createQuiz({
        title: quiz.title,
        description: quiz.description,
        questions: quiz.questions.map(q => ({
          text: q.text,
          timeLimit: q.timeLimit,
          pointValue: q.pointValue,
          options: q.options
        }))
      });

      // Navigate back to the teacher dashboard
      navigate({ to: '/teacher' });
    } catch (error) {
      console.error('Error creating quiz:', error);
      alert('Failed to create quiz. Please try again.');
    }
  };

  return (
    <div className="container max-w-6xl mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-heading font-bold">Create New Quiz</h1>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => navigate({ to: '/teacher' })}>
            Cancel
          </Button>
          <SignOut />
        </div>
      </div>

      <QuizForm onSubmit={handleCreateQuiz} />
    </div>
  );
};

export default CreateQuizPage;